import { Dispatch } from 'redux'

import * as Api from 'redux/api/Integrations'

import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import { useThunkActions } from 'redux/actions/useThunkActions'
import * as actions from './actions'

export function tryGetIntegrations() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getIntegrations())

    Api.getAll()
      .then((response) => {
        dispatch(actions.getIntegrationsSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getIntegrationsFailed())
      })
  }
}

export function tryGetFortnoxTenantStatus() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getFortnoxTenantStatus())

    Api.getFortnoxTenantStatus()
      .then((response) => {
        dispatch(actions.getFortnoxTenantStatusSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getFortnoxTenantStatusFailed())
      })
  }
}

export function tryReconnectFortnox(activeSourceId: string) {
  return (dispatch: Dispatch) => {
    // Open the tab synchronously (within the click gesture) so it is not
    // blocked, then point it at the authorize URL once we have it.
    const authWindow = window.open('', '_blank')

    if (authWindow) {
      authWindow.opener = null
    }

    Api.getFortnoxAuthUrl(activeSourceId)
      .then((response) => {
        const url = response.data.data?.url

        if (url) {
          if (authWindow) {
            authWindow.location.href = url
          } else {
            window.open(url, '_blank', 'noopener,noreferrer')
          }
        } else {
          authWindow?.close()
          dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
        }
      })
      .catch(() => {
        authWindow?.close()
        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export function tryRemoveFortnoxTenant(
  activeSourceId: string,
  tenantId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.removeFortnoxTenant())

    Api.deleteFortnoxTenant(activeSourceId, tenantId)
      .then(() => {
        dispatch(
          actions.removeFortnoxTenantSuccess({ activeSourceId, tenantId })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
      })
      .catch(() => {
        dispatch(actions.removeFortnoxTenantFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export const useIntegrationActions = () => {
  return {
    tryGetIntegrations: useThunkActions(tryGetIntegrations),
    tryGetFortnoxTenantStatus: useThunkActions(tryGetFortnoxTenantStatus),
    tryReconnectFortnox: useThunkActions(tryReconnectFortnox),
    tryRemoveFortnoxTenant: useThunkActions(tryRemoveFortnoxTenant)
  }
}
